<template>
  <div class="wlx-basic-static-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <!-- <div class="head-logo-con">
          <img src="~assets/images/wlx-basic-logo.png" alt class="logo-img-val">
        </div>-->
        <div class="head-title-con clearfix">
          <div class="fl">
            <img src="~assets/images/basic-book-img.png" alt>
          </div>
          <div class="fr head-title-word">
            <p class="p-title-1"> 物流管理1+X试点扩容院校</p>
            <p class="p-title-1">基本情况统计表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心
</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="phone-head-main">
      <p class="p-title-1"> 物流管理1+X试点扩容院校</p>
      <p class="p-title-1">基本情况统计表</p>
    </div>-->
    <div class="ph-baisc-head-main">
      <img
        src="https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/bWwrCnyQdKFJAZ6b.png"
        alt
      >
    </div>
    <div class="basic-form-main">
      <div class="basic-form-con">
        <el-form>
          <div class="form-label-title">学校信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校名称</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolName">
                    <el-input size="small" placeholder="输入学校名称" v-model="schoolName"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校层次</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolArrange">
                    <el-select placeholder="请选择学校层次" size="small" v-model="schoolArrange">
                      <el-option label="中职" :value="1"></el-option>
                      <el-option label="高职" :value="2"></el-option>
                      <el-option label="本科" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校类型</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolType">
                    <el-select placeholder="请选择学校类型" size="small" v-model="schoolType">
                      <el-option label="国示范" :value="1"></el-option>
                      <el-option label="省示范" :value="2"></el-option>
                      <el-option label="行业特色校" :value="3"></el-option>
                      <el-option label="优质校" :value="4"></el-option>
                       <el-option label="本科" :value="5"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">省份</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolType">
                    <el-select placeholder="请选择学校类型" size="small" v-model="schoolProvince">
                      <el-option
                          v-for="item in privinceData"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">城市</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolType">
                    <el-select placeholder="请选择城市" size="small" v-model="schoolCity">
                      <el-option
                          v-for="item in cityList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校地址</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolAddress">
                    <el-input size="small" placeholder="输入学校地址" v-model="schoolAddress"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">学校邮编</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolEmail">
                    <el-input size="small" placeholder="输入学校邮编" v-model="schoolEmail"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-title">试点负责人信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">负责人姓名</span>
                <div class="fr form-input-con">
                  <el-form-item prop="personInfo">
                    <el-input size="small" placeholder="请输入负责人姓名" v-model="personInfo"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">负责人职务</span>
                <div class="fr form-input-con">
                  <el-form-item prop="schoolType">
                    <el-select placeholder="请选择负责人职务" size="small" v-model="personPost">
                      <el-option label="校领导" :value="1"></el-option>
                      <el-option label="院系领导" :value="2"></el-option>
                      <el-option label="专业负责人" :value="3"></el-option>
                      <el-option label="其他" :value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">负责人手机</span>
                <div class="fr form-input-con">
                  <el-form-item prop="personPhone">
                    <el-input size="small" placeholder="请输入负责人手机" v-model="personPhone"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-title">参与证书信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">证书名称</span>
                <div class="fr form-input-con">
                  <el-form-item prop="certifyName">
                    <el-input size="small" placeholder="请输入证书名称" v-model="certifyName" disabled></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">证书等级</span>
                <div class="fr form-input-con">
                  <el-form-item prop="cerfityGrade">
                    <el-select placeholder="请选择证书等级" size="small" v-model="cerfityGrade">
                      <el-option label="初级" :value="1"></el-option>
                      <el-option label="中级" :value="2"></el-option>
                      <el-option label="高级" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <div class="pc-table-major-content">
                  <el-table
                    :data="tableData3"
                    style="width: 100%"
                    size="small"
                    class="form-table-con"
                  >
                    <el-table-column prop="marjorName" label="对应专业" align="center">
                      <template slot-scope="scope">
                        <el-form-item prop="scope.row.marjorName">
                          <el-input v-model="scope.row.marjorName" size="small"></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="近三年招生人数" align="center">
                      <el-table-column prop="totalPersonNum" label="总人数" align="center" width="100">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.totalPersonNum">
                            <el-input v-model="scope.row.totalPersonNum" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year1" label="2016年" align="center" width="100">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year1">
                            <el-input v-model="scope.row.year1" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year2" label="2017年" align="center" width="100">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year2">
                            <el-input v-model="scope.row.year2" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year3" label="2018年" align="center" width="100">
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year3">
                            <el-input v-model.number="scope.row.year3" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="phone-table-major-content">
                  <el-table
                    :data="tableData3"
                    style="width: 100%"
                    size="small"
                    class="form-table-con"
                  >
                    <el-table-column prop="marjorName" label="对应专业" align="center">
                      <template slot-scope="scope">
                        <el-form-item prop="scope.row.marjorName">
                          <el-input v-model="scope.row.marjorName" size="small"></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="近三年招生人数" align="center">
                      <el-table-column prop="totalPersonNum" label="总人数" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.totalPersonNum">
                            <el-input v-model="scope.row.totalPersonNum" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year1" label="2016年" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year1">
                            <el-input v-model="scope.row.year1" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year2" label="2017年" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year2">
                            <el-input v-model="scope.row.year2" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="year3" label="2018年" align="center" width>
                        <template slot-scope="scope">
                          <el-form-item prop="scope.row.year3">
                            <el-input v-model.number="scope.row.year3" size="small"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="add-table-tr-btn" @click="addTableTr">
                  <i class="wl-icon-tianjia"></i>
                  <span>点击添加一行</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-title">培训团队专业带头人信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">姓名</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderName">
                    <el-input size="small" placeholder="请输入姓名" v-model="leaderName"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">职务</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderPost">
                    <el-input size="small" placeholder="请输入职务" v-model="leaderPost"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">专业</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderMajor">
                    <el-input size="small" placeholder="请输入专业" v-model="leaderMajor"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">职称</span>
                <div class="fr form-input-con">
                  <el-form-item prop="leaderTitle">
                    <el-input size="small" placeholder="请输入职称" v-model="leaderTitle"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form :model="teamForm" ref="teamForm">
          <div class="form-label-title">培训团队师资信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">团队总人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teamPersonNum"
                    :rules="[
      { required: true, message: '团队总人数'},
      { type: 'number', message: '团队总人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入团队总人数"
                      type="teamPersonNum"
                      auto-complete="off"
                      v-model.number="teamForm.teamPersonNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">高级职称人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="seniorNum"
                    :rules="[
      { required: true, message: '高级职称人数'},
      { type: 'number', message: '高级职称人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入高级职称人数"
                      type="seniorNum"
                      v-model.number="teamForm.seniorNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">行业企业专家人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="expertNum"
                    :rules="[
      { required: true, message: '行业企业专家人数'},
      { type: 'number', message: '行业企业专家人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入行业企业专家人数"
                      type="expertNum"
                      v-model.number="teamForm.expertNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">学校专业教师人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teaNum"
                    :rules="[
      { required: true, message: '学校专业教师人数'},
      { type: 'number', message: '学校专业教师人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入学校专业教师人数"
                      type="teaNum"
                      v-model.number="teamForm.teaNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">专职教学管理团队人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teachTeamNun"
                    :rules="[
      { required: true, message: '专职教学管理团队人数'},
      { type: 'number', message: '专职教学管理团队人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入专职教学管理团队人数"
                      type="teachTeamNun"
                      v-model.number="teamForm.teachTeamNun"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li form-info-li-1">
                <span class="sp-form-label fl">技术服务团队人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="technologyTeamNum"
                    :rules="[
      { required: true, message: '技术服务团队人数'},
      { type: 'number', message: '技术服务团队人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入技术服务团队人数"
                      type="technologyTeamNum"
                      v-model.number="teamForm.technologyTeamNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="form-label-title">培训场地建设信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">场地地址</span>
                <div class="fr form-input-con">
                  <el-form-item prop="address">
                    <el-input
                      size="small"
                      placeholder="请输入场地地址"
                      type="address"
                      v-model="teamForm.address"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">场地面积（平米）</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="teachArea"
                    :rules="[
      { required: true, message: '场地面积（平米）'},
      { type: 'number', message: '场地面积（平米）'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入场地面积（平米）"
                      type="teachArea"
                      v-model.number="teamForm.teachArea"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">可容纳理论学习人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="stuNum"
                    :rules="[
      { required: true, message: '可容纳理论学习人数'},
      { type: 'number', message: '可容纳理论学习人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入可容纳理论学习人数"
                      type="stuNum"
                      v-model.number="teamForm.stuNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="clearfix form-info-li">
                <span class="sp-form-label fl">可容纳实践操作人数</span>
                <div class="fr form-input-con">
                  <el-form-item
                    prop="operateNum"
                    :rules="[
      { required: true, message: '可容纳实践操作人数'},
      { type: 'number', message: '可容纳实践操作人数'}
    ]"
                  >
                    <el-input
                      size="small"
                      placeholder="请输入可容纳实践操作人数"
                      type="operateNum"
                      v-model.number="teamForm.operateNum"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form>
          <div class="form-label-title">近三年完成取证类培训信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <el-table
                  :data="trainData"
                  :span-method="objectSpanMethod"
                  border
                  style="width: 100%;"
                  size="small"
                  class="form-table-con"
                  show-summary
                  sum-text="总人数"
                >
                  <el-table-column prop="trainGradeName" label="培训班名称" align="center">
                    <template slot-scope="scope">
                      <el-form-item prop="scope.row.trainGradeName">
                        <el-input v-model="scope.row.trainGradeName" size="small"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="trainNum" label="培训人数" align="center">
                    <template slot-scope="scope">
                      <el-form-item prop="scope.row.trainNum">
                        <el-input v-model="scope.row.trainNum" size="small"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="totalNum" label="总数人" align="center"></el-table-column> -->
                </el-table>
                <div class="add-table-tr-btn" @click="addTrainTable">
                  <i class="wl-icon-tianjia"></i>
                  <span>点击添加一行</span>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <el-form>
          <div class="form-label-title">课程体系建设基本信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <el-input type="textarea" v-model="courseBasicInfo" rows="7"></el-input>
              </div>
            </div>
          </div>
          <div class="form-label-title">实训设备设施基本信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con clearfix">
              <div class="clearfix form-info-li">
                <el-input type="textarea" v-model="equipmentInfo" rows="7"></el-input>
              </div>
            </div>
          </div>
          <div class="form-label-title">管理制度和保障条件基本信息</div>
          <div class="form-info-content clearfix">
            <div class="form-info-con">
              <div class="clearfix form-info-li">
                <el-input type="textarea" v-model="managerInfo" rows="7"></el-input>
              </div>
            </div>
          </div>
        </el-form>
        <div class="submit-btn-con">
          <el-button size="small" type="primary" @click="fanhui">返回</el-button>
          <el-button size="small" type="primary" @click="submitData('teamForm')">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: ""
        }
  },
  data() {
    return {
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      schoolName: "",
      schoolArrange: "",
      schoolType: "",
      schoolAddress: "",
      schoolEmail: "",
      personInfo: "",
      personPhone: "",
      personPost:'',
      certifyName: "物流管理",
      cerfityGrade: "",
      tableData3: [
        {
          marjorName: "",
          totalPersonNum: "",
          year1: "",
          year2: "",
          year3: ""
        },
        {
          marjorName: "",
          totalPersonNum: "",
          year1: "",
          year2: "",
          year3: ""
        },
        {
          marjorName: "",
          totalPersonNum: "",
          year1: "",
          year2: "",
          year3: ""
        }
      ],
      leaderName: "",
      leaderPost: "",
      leaderTitle: "",
      leaderMajor: "",

      trainData: [
        {
          trainGradeName: "",
          trainNum: ""
        },
        {
          trainGradeName: "",
          trainNum: ""
        },
        {
          trainGradeName: "",
          trainNum: ""
        }
      ],
      courseBasicInfo: "",
      equipmentInfo: "",
      managerInfo: "",
      trainTotalNum: 0,
      teamForm: {
        teamPersonNum: "",
        seniorNum: "",
        expertNum: "",
        teaNum: "",
        teachTeamNun: "",
        technologyTeamNum: "",
        address: "",
        teachArea: "",
        stuNum: "",
        operateNum: ""
      },
      privinceData:[],
      schoolProvince:'',
      schoolCity:"",
      cityList:[],
    };
  },
  watch: {},
  created(){
      this.getQuestionnaireInfo();
      this.getProvinceData();
  },
  methods: {
    // 获取城市 省市联动
    getCityList(){
        this.$http.post("/api/partner/PartnerApplication/getCityList", {
            province:this.schoolProvince
        }).then(rst => {
            if (rst.code > 0) {
                this.cityList = rst.cityList;
            }
        });
    },
    getProvinceData(){
      this.$http.post('/api/XOrg/Questionnaire/getAllProvinceList').then(res => {
        if(res.code > 0){
         this.privinceData = res.province;
        }
      });
    },
    addTableTr() {
      this.tableData3.push({
        marjorName: "",
        totalPersonNum: "",
        year1: "",
        year2: "",
        year3: ""
      });
    },
    addTrainTable() {
      this.trainData.push({
        trainGradeName: "",
        trainNum: "",
        totalNum: ""
      });
    },
    getTableInfo() {
      console.log(this.tableData3);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return {
          rowspan: this.trainData.length,
          colspan: 1
        };
      }
    },
    getSummaries(param) {},
    submitData(formName) {
      this.schoolType;
      this.schoolArrange;
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.trainData.forEach(val => {
            console.log(Number(val.trainNum));
            this.trainTotalNum = this.trainTotalNum + Number(val.trainNum);
          });
          debugger;
          this.$http
            .post("/api/XOrg/QuestionnaireManager/editNaire", {
              id: this.id,
              SchoolName: this.schoolName,
              SchoolLevel: this.schoolArrange,
              SchoolType: this.schoolType,
              Province:this.schoolProvince,
              SchoolAddress: this.schoolAddress,
              SchoolEmail: this.schoolEmail,
              ResponNameOrJob: this.personInfo,
              Phone: this.personPhone,
              Job:this.personPost,
              Certificate: this.certifyName,
              CertificateLeavel: this.cerfityGrade,
              Major: JSON.stringify(this.tableData3),
              TeaTeamName: this.leaderName,
              TeaTeamJob: this.leaderPost,
              TeaTeamTitle: this.leaderTitle,
              TeaTeamMajor: this.leaderMajor,
              PersonCount: this.teamForm.teamPersonNum,
              SeniorCount: this.teamForm.seniorNum,
              XpertCount: this.teamForm.expertNum,
              TeaCount: this.teamForm.teaNum,
              TeachingCount: this.teamForm.teachTeamNun,
              SkillCount: this.teamForm.technologyTeamNum,
              Address: this.teamForm.address,
              Area: this.teamForm.teachArea,
              StudyCount: this.teamForm.stuNum,
              TrainCount: this.teamForm.operateNum,
              TrainSituation: JSON.stringify(this.trainData),
              TrainSituationCount: this.trainTotalNum,
              CourseBuildContent: this.courseBasicInfo,
              DeviceImpleContent: this.equipmentInfo,
              ManagerContent: this.managerInfo
            })
            .then(res => {
              if (res.code > 0) {
                setTimeout(that.goclpp(),3000);
              }
            });
          console.log(this.trainTotalNum);
        } else {
          this.$message.error("信息填写错误!!");
          return false;
        }
      });
    },
    fanhui(){
        this.$router.push({
            name:'teaPilotManager'
        })
    },
     //获取调查表详情
    getQuestionnaireInfo(){
      var that = this;
      this.$http.post('/api/XOrg/QuestionnaireManager/getNaireInfo',
      {
        id: that.id
      }).then(rst => {
        if(rst.code > 0){
            this.schoolName= rst.questionnaire.SchoolName;
            this.schoolArrange= rst.questionnaire.SchoolLevel;
            this.schoolType = rst.questionnaire.SchoolType;

            this.personInfo= rst.questionnaire.ResponNameOrJob;
            this.personPhone= rst.questionnaire.Phone;
            this.personPost = rst.questionnaire.Job==0?"":rst.questionnaire.Job;
            this.certifyName= rst.questionnaire.Certificate;
           
            this.cerfityGrade = rst.questionnaire.CertificateLeavel;

            this.tableData3= JSON.parse(rst.questionnaire.Major);
            this.leaderName= rst.questionnaire.TeaTeamName;
            this.leaderPost= rst.questionnaire.TeaTeamJob;
            this.leaderTitle= rst.questionnaire.TeaTeamTitle;
            this.leaderMajor= rst.questionnaire.TeaTeamMajor;
            this.teamForm = {
                    teamPersonNum: rst.questionnaire.PersonCount,
                    seniorNum: rst.questionnaire.SeniorCount,
                    expertNum: rst.questionnaire.XpertCount,
                    teaNum: rst.questionnaire.TeaCount,
                    teachTeamNun: rst.questionnaire.TeachingCount,
                    technologyTeamNum: rst.questionnaire.SkillCount,
                    address: rst.questionnaire.Address,
                    teachArea: rst.questionnaire.Area,
                    stuNum: rst.questionnaire.StudyCount,
                    operateNum: rst.questionnaire.TrainCount
                }
            this.trainData= JSON.parse(rst.questionnaire.TrainSituation);
            this.trainTotalNum= rst.questionnaire.TrainSituationCount;
            this.courseBasicInfo= rst.questionnaire.CourseBuildContent;
            this.equipmentInfo= rst.questionnaire.DeviceImpleContent;
            this.managerInfo = rst.questionnaire.ManagerContent;
            this.schoolAddress = rst.questionnaire.SchoolAddress;
            this.schoolEmail = rst.questionnaire.SchoolEmail;
            this.schoolProvince = rst.questionnaire.Province;
            this.schoolCity = rst.questionnaire.City;
            if(this.schoolProvince != ""){
              this.getCityList();
            }
        }        
      })
    }, 
    goclpp() {
      this.$router.push({
        name:'teaPilotManager'
      });
    }
  }
};
</script>

<style lang="scss">
.wlx-basic-static-wrapper {
  // height: 100%;
  background: #f0f6ff;
  overflow: auto;
  .ph-baisc-head-main {
    display: none;
    img {
      width: 100%;
    }
  }
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }

    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 68px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
    // .p-title-2 {
    //   margin-top: 10px;
    //   text-align: right;
    // }
  }
  .phone-head-main {
    display: none;
    background: #056ef5;
    text-align: center;
    color: #fff;
  }
  .pc-table-major-content {
    display: block;
  }
  .phone-table-major-content {
    display: none;
  }
  .basic-form-main {
    margin: 0 auto;
    margin-top: -325px;
    padding: 20px 0;
    width: 1000px;
    background: #fff;
  }
  .basic-form-con {
    margin: 0 20px;
    padding: 20px;
    background: #f0f0f0;
    min-height: 400px;
    .form-label-title {
      margin-top: 10px;
      margin-bottom: 20px;
      padding-bottom: 12px;
      color: #0155d1;
      font-size: 24px;
      border-bottom: 1px solid #cccccc;
    }
    .form-info-li {
      //   margin: 15px 0;
    }
    .form-info-li-1 {
      margin: 0;
    }
    .form-info-con {
      float: right;
      width: 740px;
    }
    .form-input-con {
      .el-input {
        width: 420px;
      }
    }
    .sp-form-label {
      margin-top: 5px;
      font-size: 16px;
    }
    .form-table-con {
      .el-input {
        .el-input__inner {
          border: none;
        }
      }
      .el-table__header-wrapper {
        tr th {
          background: #f7f7f7;
          color: #000;
        }
      }
    }
    .add-table-tr-btn {
      padding: 10px 0;
      text-align: center;
      color: #0155d1;
      font-size: 16px;
      background: #fff;
      i {
        margin-right: 10px;
      }
    }
  }
  .submit-btn-con {
    padding: 20px 0;
    text-align: center;
  }
}
@media only screen and (max-width:700px) {
  .wlx-basic-static-wrapper {
    .basic-head-main {
      display: none;
    }
    .ph-baisc-head-main {
      display: block;
    }
    .phone-head-main {
      display: block;
    }
    .basic-form-main {
      margin: 0;
      padding: 0;
      width: 100%;
    }
    .basic-form-con {
      margin: 0;
      padding: 10px;
      .pc-table-major-content {
        display: none;
      }
      .phone-table-major-content {
        display: block;
      }
      .form-label-title {
        padding-top: 15px;
      }
      .form-info-con {
        float: none;
        width: 100%;
      }
      .form-label-title {
        margin-bottom: 10px;
        padding-bottom: 10px;
        font-size: 16px;
      }
      .sp-form-label {
        font-size: 14px;
        color: #999;
        float: none !important;
      }
      .form-input-con {
        float: none !important;
        .el-input,
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>
